var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 36,
    fill: "none",
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M0.333984 9.50359C0.333984 7.84607 1.21989 6.30418 3.38881 5.72376C5.55774 5.14334 26.3 0.5 26.3 0.5C27.9872 0.5 29.3549 1.84368 29.3549 3.5012V14.7557V26.0102C29.3549 27.6677 27.9872 29.0114 26.3 29.0114L3.38881 33.5132C1.70168 35.0138 0.333984 33.6701 0.333984 32.0126V9.50359Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M0.200195 9.85669C0.200195 7.92369 1.7672 6.35669 3.7002 6.35669H28.9002C30.8332 6.35669 32.4002 7.92369 32.4002 9.85669V31.5567C32.4002 33.4897 30.8332 35.0567 28.9002 35.0567H3.7002C1.7672 35.0567 0.200195 33.4897 0.200195 31.5567V9.85669Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M16.2998 17.5566C16.2998 15.6236 17.8668 14.0566 19.7998 14.0566H30.9998C32.9328 14.0566 34.4998 15.6236 34.4998 17.5566V23.1566C34.4998 25.0896 32.9328 26.6566 30.9998 26.6566H19.7998C17.8668 26.6566 16.2998 25.0896 16.2998 23.1566V17.5566Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M24.7117 20.5783C24.7117 21.8605 23.6722 22.8999 22.39 22.8999C21.1078 22.8999 20.0684 21.8605 20.0684 20.5783C20.0684 19.296 21.1078 18.2566 22.39 18.2566C23.6722 18.2566 24.7117 19.296 24.7117 20.5783Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon (3).ae78bdcb1d41046d685ef3719becd31f.svg";
export { ForwardRef as ReactComponent };